import { Component, OnInit } from '@angular/core';
import { AdfiGraphqlService } from '@services/adfi-graphql.service';
import { AdfiGrowlService } from '@services/adfi-growl.service';
import { LoadingService } from '@services/loading.service';
import { AdfiService } from '@services/adfi-service';
import { PeriodState } from '@Interfaces/index';

@Component({
  selector: 'app-plataform-backup',
  templateUrl: './plataform-backup.component.html',
  styleUrls: ['./plataform-backup.component.scss']
})
export class PlataformBackupComponent implements OnInit {

  allCenters: any[];
  countCenters: number;
  total: number = 0;
  canExport = false;

  constructor(
    private adfiGrowlService: AdfiGrowlService,
    private graph: AdfiGraphqlService,
    private loading: LoadingService,
    private adfiService: AdfiService
  ) { }

  async ngOnInit() {
    this.canExport = this.adfiService.validPermission('BlockingPlatform', 'export', PeriodState.NO_STATUS);

    this.loading.show();
    const filter = 'id_not: { list: [1500101, 1500102, 1500103]} ';

    this.countCenters = await this.graph.countEntity('prCentroCostos', filter);
    const next = (val) => {
      this.allCenters = val;
      this.loading.hide();
    };
    const error = (err) => {
      this.adfiGrowlService.info('Error al obtener el listado de Instituciones', err);
    };
    this.graph.getEntity('prCentroCostos', '_id deDescripcion documentAct fileRut',
      this.countCenters, filter, { next, error });
  }

async download() {
  this.loading.show();
  const concurrency = 3;
  let index = 0;
  let running = 0;

  const nextBatch = async () => {
    while (index < this.allCenters.length && running < concurrency) {
      running++;
      const center = this.allCenters[index++];
      this.getFolder(center)
        .finally(() => {
          running--;
          nextBatch();
        });
    }
    if (index >= this.allCenters.length && running == 0) {
      this.loading.hide();
      this.compressFolders();
      this.total = 0;
    }
  };

  nextBatch();
}

  async getFolder(center) {
    return new Promise((resolve, reject) => {
      const nameClass = 'plataform-backup';
      const type = '';
      const actions = 'generate';
      const group = '';
      const customReturn = '';

      const next = (val) => {
        this.total++;
        resolve(val);
      };
      const error = (e) => {
        this.adfiGrowlService.errorMessage(e);
        this.loading.hide();
        reject(e);
      };
      let filters = JSON.stringify({ id: center._id, deDescripcion: center.deDescripcion, documentAct: center.documentAct, fileRut: center.fileRut, action: 'generate' });
      this.graph.createEntity('Report', { nameClass, filters, type, actions, group }, customReturn, { next, error });
    });
  }

  compressFolders() {
    const nameClass = 'plataform-backup';
    const type = '';
    const actions = 'compress';
    const group = '';
    const filters = JSON.stringify(this.allCenters);
    const customReturn = '';

    this.loading.show();

    const next = (val) => {
      this.adfiGrowlService.success('Correcto', 'Se ha generado el archivo, por favor verifique su correo');
      this.loading.hide();
    };

    const error = (e) => {
      this.adfiGrowlService.errorMessage(e);
      this.loading.hide();
    };
    this.graph.createEntity('Report', { nameClass, filters, type, actions, group }, customReturn, { next, error });
  }

}
